import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { tap } from 'rxjs';
import { format } from 'date-fns';

export interface GetAlarmsRequest {
    keyword?: string;
    statuses?: number[];
    floorIDs?: number[];
    dateTimeStart?: string;
    dateTimeEnd?: string;
    page?: number;
    pageSize?: number;
}

export interface GetAlarmsResponse {
    data: {
        alarmId: string;
        deviceName: string;
        systemName: string;
        floorName: string;
        spaceName: string;
        description: string;
        status: 0 | 1;
        triggerTime: string;
        closeTime: string;
    }[];
    pagination: {
        page: number;
        pageSize: number;
        totalCount: number;
    };
}

export interface GetAlarmsExportRequest {
    keyword?: string;
    statuses?: number[];
    floorIDs?: number[];
    startDate?: string;
    endDate?: string;
}

export interface GetAlarmsStatisticsResponse {
    sampleTime: string;
    totalUnclosedCount: number;
    systemStatistics: {
        systemId: number;
        systemName: string;
        unclosedCount: number;
        percentage: number;
    }[];
}

@Injectable({
    providedIn: 'root'
})
export class AlarmsService {
    private http = inject(HttpClient);
    private readonly baseUrl = environment.apiUrl + '/api/Alarms';

    getAlarms(request: GetAlarmsRequest) {
        return this.http.get<GetAlarmsResponse>(`${this.baseUrl}`, { 
            params: { ...request } 
        });
    }

    exportAlarms(request: GetAlarmsExportRequest) {
        return this.http.get(
            `${this.baseUrl}/Export`,
            {
                params: { ...request },
                responseType: "blob",
            },
        ).pipe(
            tap((blob: Blob) => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");

                link.href = url;
                link.style.display = "none";
                link.download = `告警紀錄_${format(new Date(), "yyyyMMdd")}.xlsx`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }),
        );
    }

    apiGetAlarmsStatistics() {
        return this.http.get<GetAlarmsStatisticsResponse>(`${this.baseUrl}/Statistics`);
    }
}
